






































































































import CompanySheet from "@/components/company/CompanySheet.vue";
import DropAreaMulti from "@/components/files/DropAreaMulti.vue";
import PreselectTemplateCard from "@/components/partner/PreselectTemplateCard.vue";
import MNoContent from "@/components/utility/mmmint/MNoContent.vue";
import MTextField from "@/components/utility/mmmint/MTextField.vue";
import { PreselectTemplateKeysEnum } from "@/lib/enum/preselect-template-keys.enum";
import { RentalStatusEnum } from "@/lib/enum/rental-status.enum";
import { IDialog } from "@/lib/interfaces/dialog.interface";
import { handleError } from "@/lib/utility/handleError";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { InvoiceParty } from "@/models/invoice-party.entity";
import { Reference } from "@/models/reference.entity";
import { IRental, Rental } from "@/models/rental.entity";
import { ISharedContent, SharedContent } from "@/models/shared-content.entity";
import { ResourceEnum } from "@/store/enum/authResourceEnum";
import { UserModule } from "@/store/modules/me-user.store";
import { PartnerModule } from "@/store/modules/partner";
import { mixins } from "vue-class-component";
import { Component, Prop, Ref, Watch } from "vue-property-decorator";
import RentalApprovalLimitsSheet from "./RentalApprovalLimitsSheet.vue";
import RentalForm from "./RentalForm.vue";

enum Steps {
  FORM = "form",
  SEND_MAIL = "sendMail"
}

@Component({
  components: {
    PreselectTemplateCard,
    CompanySheet,
    MNoContent,
    RentalForm,
    MTextField,
    DropAreaMulti,
    RentalApprovalLimitsSheet
  },
  filters: {}
})
export default class ReportRentalCreateDialog extends mixins(PermissionMixin) implements IDialog {
  readonly Steps = Steps;
  readonly PreselectTemplateKeysEnum = PreselectTemplateKeysEnum;

  @Ref("templateCard")
  templateCard!: PreselectTemplateCard;

  @Prop({ default: false }) value!: boolean;

  dialog: boolean = this.value;

  @Watch("value")
  onValueChange(val: boolean) {
    this.dialog = val;
  }

  @Watch("dialog")
  onDialogChange(val: boolean) {
    this.$emit("input", val);
  }

  step = Steps.FORM;
  rental: IRental = new Rental({ partnerId: this.partner.id, status: RentalStatusEnum.ACTIVE });
  sharedContent: ISharedContent = new SharedContent({ partnerId: this.partner.id });

  requestsLoading = false;

  file: File | null = null;

  isValid = false;

  get files(): File[] {
    if (this.file) {
      return [this.file];
    }
    return [];
  }

  set files(files: File[]) {
    if (files.length > 0) {
      this.file = files[0];
    } else {
      this.file = null;
    }
  }

  get partner() {
    return PartnerModule.partner;
  }

  get report() {
    return PartnerModule.report;
  }

  get duration(): number {
    return this.rental.periodInDays;
  }

  get context() {
    return {
      rental: this.rental,
      sharedContent: this.sharedContent,
      partner: this.partner,
      report: this.report,
      url: { sharing: this.sharedContent.url }
    };
  }

  get validForm() {
    return this.isValid && this.report.rentalCompanyId;
  }

  get myUserId() {
    return UserModule.userId;
  }

  get attachmentFileFilters() {
    return this.report.refFilter;
  }

  async createRequests() {
    if (this.rental.id) {
      throw new Error("Rental request ID is already defined");
    }

    if (!this.report.rentalCompanyId) {
      throw new Error("Rental company ID is not defined in the report");
    }

    if (!this.report.rentalCompany) {
      await this.report.fetchRentalCompany().catch(handleError);
    }

    if (!this.report.rentalCompany) {
      throw new Error("Error loading rental entity");
    }

    this.requestsLoading = true;

    try {
      this.rental.seller = this.report.rentalCompany.invoiceParty;
      this.rental.buyer = new InvoiceParty({ name: this.partner.companyName });

      this.rental.refs = [];

      if (this.myUserId) {
        this.rental.assignees = [this.myUserId];
      }

      this.rental.refs.push(new Reference({ refId: this.report.id, refType: ResourceEnum.REPORT }));

      if (this.report.vehicleId) {
        this.rental.refs.push(new Reference({ refId: this.report.vehicleId, refType: ResourceEnum.VEHICLE }));
      }

      this.rental.partnerId = this.report.partnerId;
      this.rental.reportId = this.report.id;

      await this.rental.create();

      if (this.file) {
        const rentalDocument = await this.rental.uploadDocument(this.file);
        this.rental.documentId = rentalDocument.id;
        this.rental.document = rentalDocument;
        await this.rental.updatePartial({ documentId: rentalDocument.id });
      }

      if (this.report.person?.activeSharedContent) {
        await this.report.person.activeSharedContent.addRef(
          new Reference({ refId: this.rental.id, refType: ResourceEnum.RENTAL }),
          true
        );
        this.sharedContent = this.report.person.activeSharedContent;
      } else {
        this.sharedContent.reportId = this.report.id;
        this.sharedContent.refs = [
          ...this.rental.refs,
          new Reference({ refId: this.report.id, refType: ResourceEnum.REPORT })
        ];

        if (this.report.personId) {
          this.sharedContent.personIds = [this.report.personId];
        }

        if (this.report.person?.primaryEmail) {
          this.sharedContent.emailAddresses = [this.report.person.primaryEmail];
        }

        if (this.rental.id) {
          this.sharedContent.refs.unshift(new Reference({ refId: this.rental.id, refType: ResourceEnum.RENTAL }));
        } else {
          throw new Error("Rental request ID is not defined");
        }

        try {
          await this.sharedContent.create();
          if (this.report.person) {
            this.report.person.activeSharedContent = this.sharedContent;
          }
        } catch (e) {
          handleError(e);
        }
      }

      this.report.rentals.unshift(this.rental);

      this.$emit("create:sharedContent", this.sharedContent);
    } catch (e) {
      handleError(e);
    }
    this.requestsLoading = false;
    return {
      rental: this.rental,
      sharedContent: this.sharedContent
    };
  }

  async createAndClose() {
    const request = await this.createRequests();
    request.sharedContent.copyUrl();
    this.close();
  }

  async createReportAndSend() {
    await this.createRequests();
    this.step = Steps.SEND_MAIL;
  }

  async sendMail() {
    await this.templateCard?.send();
    this.close();
  }

  async close() {
    this.dialog = false;
    this.reset();
  }

  open() {
    this.reset();
    this.dialog = true;
  }

  reset() {
    this.step = Steps.FORM;
    this.rental = new Rental({ partnerId: this.partner.id, status: RentalStatusEnum.ACTIVE });
    this.file = null;
    this.sharedContent = new SharedContent({ partnerId: this.partner.id });
  }
}
